<template>
  <div :class="['edit-button', classe]" slot="edit">
    <font-awesome-icon
      :tabindex="0"
      v-b-tooltip.hover
      title="Editar seleção"
      :class="['voltar-pergunta', { 'loading-edit': loading }]"
      icon="edit"
      @click="handleEdita()"
      @keyup.enter="handleEdita()"
    />
  </div>
</template>

<script lang="js">
export default {
    name: 'EditButton',

    props: {
        edita: Function,
        classe: String,
        loading: Boolean,
    },

    methods: {
      handleEdita: function () {
        if (this.loading) {
          return
        }
        this.edita()
      },
    }
}
</script>

<style lang="scss" scoped>
.edit-button .svg-inline--fa {
  width: 16px;
  height: 18px;
  border-radius: 2px;
  margin: 0.65rem 4px 0 1px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;

  cursor: pointer;
}

.edit-button-component.antecipacao .svg-inline--fa {
  background: #72b118;
}

.voltar-pergunta {
  position: static !important;
  &:focus {
    background: #91919198;
  }
}

.preferencia_tarifaria,
.exportacao,
.class_importacao {
  color: var(--importacao);
}

.pis_cofins,
.cide_combustivel {
  color: var(--pis-cofins);
}

.icms_interno svg,
.icms_st,
.carga_liquida,
.difal,
.antecipacao {
  color: var(--icms);
}

.ipi {
  color: var(--ipi);
}

.loading-edit {
  opacity: 0.3;
  cursor: not-allowed !important;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

@media only print {
  .edit-button {
    display: none;
  }
}
</style>
